<template>
  <div>
    <b-tabs>
      <b-tab class="tab-margin" v-if="isAdmin()" title="チャット">
        <chat-main/>
      </b-tab>
      <!-- <b-tab class="tab-margin" v-if="isAdmin()" title="過去検索履歴">
        <chat-history/>
      </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import ChatMain from '@/components/chat-ai/ChatMain';
import ChatHistory from '@/components/chat-ai/ChatHistory';
import * as api from '@/api';

export default {
  mixins: [BaseView],
  data() {
    return {}
  },
};

Vue.component('chat-main', ChatMain);
Vue.component('chat-history', ChatHistory);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
